import useAppStore from "@/context/store";
import { useAsyncEffect } from "ahooks";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { ExcludeDestoryModal } from "../HBModal/ModalWrap";

export function usePinDetail() {
  const router = useRouter();
  const currentPin = useAppStore((s) => s.currentPin);

  // 用来判断是否需要执行拦截操作
  const needInterceptRef = useRef(null);
  const pinDetailIns = useRef(null);

  useAsyncEffect(async () => {
    if (currentPin) {
      needInterceptRef.current = true;

      if (!pinDetailIns.current) {
        const { PinDetailDialog } = await import("./modal");
        pinDetailIns.current = PinDetailDialog.open({
          // 标识弹窗名称, 全量销毁时，需要不关闭的弹窗
          name: ExcludeDestoryModal.pinDetail,
        });
      }
    } else {
      pinDetailIns.current?.destroy();
      pinDetailIns.current = null;
    }
  }, [currentPin]);

  useEffect(() => {
    /**
     * 这是为了解决页面如果有服务端渲染的方法，
     * 打开详情弹窗，再通过histor.back()这种方法返回的时候，会记录不了前置的滚动位置的问题
     */
    router.beforePopState(({ as, options }) => {
      if (needInterceptRef?.current && !/^\/pins\/\d*$/.test(as)) {
        needInterceptRef.current = false;
        // shallow为true则不执行服务端渲染的方法
        options.shallow = true;
        router.push(as, undefined, options);
        // 阻止路由更改
        return false;
      } else {
        return true;
      }
    });
  }, [router]);
}
